<template>
  <div>
       <!--采购报表-->
      <Card :bordered="false" dis-hover>
          <p slot="title">详情</p>
          <!--<ButtonGroup shape="circle" slot="extra">
              <Button type="primary" @click="point()">
                  打印
              </Button>
          </ButtonGroup>-->
          <Row>
              <Col span="8"><strong>供应商：</strong> <span class="result">{{purchase.suppliername}}</span></Col>
              <Col span="8"><strong>商品金额：</strong> <span class="result">￥{{purchase.money}}</span></Col>
              <Col span="8"><strong>单据编号：</strong> <span class="result">{{purchase.purchasecode}}</span></Col>
              <Col span="8"><strong>制单人：</strong> <span class="result">{{purchase.adminName}}</span></Col>
              <Col span="8"><strong>商品数量：</strong> <span class="result">{{purchase.total}}</span></Col>
              <Col span="8"><strong>建立时间：</strong> <span class="result">{{purchase.time}}</span></Col>
              <Col span="8"><strong>结算账户：</strong> <span class="result">{{purchase.bankFields.bankname}}</span></Col>
              <Col span="8"><strong>实付金额：</strong> <span class="result">￥{{purchase.paymoney}}</span></Col>
            <!--  <Col span="8"><strong>本单欠款：</strong> <span class="result">{{purchase.nomoney}}</span></Col>-->
          </Row>
      </Card>
      <table slot="content" class="ive-table" v-for="(item, index) in purchase.pgoods" :key="index">
          <thead>
              <th>商品详情</th>
              <th>名称/货号</th>
              <th>规格/颜色</th>
              <th>单价</th>
              <th>数量</th>
          </thead>
          <tbody>
          <tr align="center" v-for="(k,v) in purchase.pgoods[index].goodsItem">
              <td width="300" :rowspan="v" v-if="v==0">
                  <Fy-Img
                          :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                          :Width="100"
                          :Height="100"
                  ></Fy-Img>
              </td>
              <td>{{item.goodsname}} / {{item.goodscode}}</td>
              <td>{{k.size}} / {{k.color}}</td>
              <td>{{k.cprice}}</td>
              <td>{{k.quantity}}</td>
          </tr>
          </tbody>
      </table>
  </div>
</template>
<script>
    import {getLodop} from '@js/LodopFuncs'
export default {
  data() {
    return {
        cid:'',
        sid:'',
        purchase:{}
    };
  },
    created: function() {
        //获取用户信息
        this.cid= JSON.parse(localStorage.getItem('shop')).cid
        this.sid = JSON.parse(localStorage.getItem('shop')).id

        this.getPurchaseId(this.$route.query.id)
    },

  methods: {
      //获取采购单
      getPurchaseId(id){
          this.$Api.getPurchaseId({
               id:id
          }).then(res => {
              if(res.code==200){
                  this.purchase = res.data
              }else {
                  this.$Message.warning(res.msg);
              }
          });

      },
      point(){
          /*** 采 购报表不可打印 **/
          var orderType=''
          if(this.purchase.status==3){
              orderType='采购单撤销单'
          }
          var username= this.purchase.suppliername

          var adminName = this.purchase.adminName
          var zdName= JSON.parse(localStorage.getItem('adminUser')).name //制单员
          var markcode = this.purchase.purchasecode
          var zdtime = this.purchase.time
          var paymoney = 'RMB ' + this.purchase.paymoney
          var nomoney = 'RMB ' + this.purchase.nomoney
          //var totalmoney = 'RMB ' + this.purchase.totalmoney

          var shopname = JSON.parse(localStorage.getItem('shop')).name
          var phone = JSON.parse(localStorage.getItem('shop')).phone
          var lxaddress= JSON.parse(localStorage.getItem('shop')).address //收货地址
          var countmoney = 0
          var strTr=''
          var count=0
          this.purchase.pgoods.forEach((item,index)=>{
              item.goodsItem.forEach((k,v)=>{
                  count+=k.quantity
                  countmoney+=k.quantity*k.cprice
                  strTr=strTr+'<tr><td>'+item.goodsname+'/'+item.goodscode+'</td><td id="spacing"><span>'+k.size+'</span>/'+k.color+'</td><td id="spacing">'+k.quantity+'</td><td id="spacing">'+k.cprice+'</td><td id="spacing">'+k.cprice*k.quantity+'</td></tr>'
              })
          })
          var strTable='<table><tr><td style="width: 26%">商品/货号</td><td style="width: 26%">规格/颜色</td><td >数量</td><td >金额</td><td >小计</td></tr>'+strTr+'</table>';
          var strStyles=''
          var LODOP = getLodop();
          var strPName=LODOP.GET_PRINTER_NAME(-1); //获取打印机的名称
          if(strPName.search("Jolimark 24-pin printer") != -1){ //针式打印机
              strStyles=""
               strStyles="<style>table tr td{border: 1pt solid #000000; border-collapse:collapse;}#count{border: 1pt solid #000000; border-top: 0;width: 95.8%; margin-left: 1.5pt} </style>"
          }else {
              strStyles=''

          }
          var strStyle="<style> *{margin: 0;padding: 0;}#contentse{font-size: 9pt;word-wrap:break-word}#title{font-size: 16pt;text-align: center}table{width: 100%;margin-top: 5pt}" +
              "table tr td{height: 16pt;border-top:1pt #000000 dashed;white-space:normal; word-break:break-all;padding-right: 5pt}#title{ text-align: center; padding-top: 10pt; }" +
              ".list {list-style: none;  line-height: 10pt; }" +
              "#zds{width: 100%; margin:10pt auto;height: 50pt}" +
              "#count{padding:5pt 10pt 5pt 0pt;margin-bottom: 5pt; border-top:1pt #000000 dashed;border-bottom:1pt #000000 dashed;}</style>"
          var time=LODOP.FORMAT("TIME:yyyy-mm-dd hh:mm:ss","now");//获取当前的时间
          var str=strStyle+strStyles+'<section id="contentse"><p id="title">'+orderType+'</p> ' +
              '<ul class="list"><li>客户：'+username+'</li>' +
              '<li>销售员：'+adminName+'</li>' +
              '<li>制单员：'+zdName+'</li>' +
              '<li>单号：'+markcode+'</li>' +
              '<li>业务日期：'+zdtime+'</li>' +
              '</ul>'+
              strTable+
              '<p id="count">合计：'+count+'<span style="padding-left: 50pt">总价：'+countmoney+'</span></p>'+
              '<ul class="list">'+
              '<li>实收金额：'+paymoney+'</li>' +
              '<li>本单欠款：'+nomoney+'</li>' +
              '<li>商品金额：RMB '+countmoney+'</li>' +
              '<li>打印时间：'+time+'</li>' +
              '<li>店铺名称：'+shopname+'</li>' +
              '<li>联系方式：'+phone+'</li>' +
              '<li>联系地址：'+lxaddress+'</li>' +
              '</ul>'+
              '<p id="zds">掌大师，轻松管理每一天。客服热线:400-801-6580</p></section>'
          this.Printing(LODOP,str)
      },


  }
};
</script>

<style lang="scss" scoped>
  .form-title{

    line-height: 54px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
.result{
    display: inline-block;
    margin-bottom: 15px;
}
  .ive-table{
      margin-top: 20px;
      width: 100%;
      border-collapse: collapse;
      th{
          background: #bfdeff;
          padding: 10px;
      }
      tr td{
          border: 1px solid #ececec;
          padding: 10px;
      }
  }
</style>